
// api/helpers.ts

export const localDB = {
  get: <T>(key: string, defaultData: T): T => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultData;
    } catch {
      return defaultData;
    }
  },
  set: <T>(key: string, data: T): void => {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error('Error writing to local DB', e);
    }
  },
  updateItem: <T extends { id: string }>(key: string, item: T, defaultList: T[]): T[] => {
    const list = localDB.get<T[]>(key, defaultList);
    const index = list.findIndex(i => i.id === item.id);
    let newList;
    if (index >= 0) {
      newList = [...list];
      newList[index] = item;
    } else {
      newList = [item, ...list];
    }
    localDB.set(key, newList);
    return newList;
  },
  deleteItem: <T extends { id: string }>(key: string, id: string, defaultList: T[]): T[] => {
    const list = localDB.get<T[]>(key, defaultList);
    const newList = list.filter(i => i.id !== id);
    localDB.set(key, newList);
    return newList;
  }
};
